const devices = (state = [], action) => {
    switch (action.type) {
        case 'DEVICE_MICROFONE':
        return {
            ...state,
            microfone: action.microfone
            }
        case 'DEVICE_AUDIO':
        return {
            ...state,
            audio: action.audio
            }
        case 'DEVICE_RING':
        return {
            ...state,
            ring: action.ring
            }
        
              default:
              return state
    }
  }
  
  export default devices